import { Auth, type IAuth } from "@/core/data_sources/models/APIAuth";
import { User, type IUser } from "@/core/data_sources/models/APIUser";
import { BaseRequestClient } from "@/core/utils/request";

import { State } from "../";

export class AuthState extends State<Partial<{ user: IUser; auth: IAuth }>> {
  constructor() {
    const auth = localStorage.getItem("auth")
      ? new Auth(JSON.parse(localStorage.getItem("auth")!))
      : null;
    const user = localStorage.getItem("user")
      ? new User(JSON.parse(localStorage.getItem("user")!))
      : null;
    if (!auth && !user) {
      super(null);
    } else {
      super({
        auth: auth ? auth : undefined,
        user: user ? user : undefined,
      });
      BaseRequestClient.defaults.headers.common["Authorization"] = auth
        ? auth.getAuthorizationHeader()
        : undefined;
    }
  }

  addAuth(auth: IAuth) {
    const prev = this._observable.value;
    this._observable.next(prev ? { ...prev, auth } : { auth });
    localStorage.setItem("auth", JSON.stringify(auth.getAuth()));
  }

  addUser(user: IUser) {
    const prev = this._observable.value;
    this._observable.next(prev ? { ...prev, user } : { user });
    localStorage.setItem("user", JSON.stringify(user.getUser()));
  }

  clear() {
    this._observable.next(null);
    localStorage.removeItem("auth");
    localStorage.removeItem("user");
    BaseRequestClient.defaults.headers.common["Authorization"] = "";
  }
}
